import React, { useEffect, useState, useRef, useCallback, useContext } from 'react'
import { Switch, Route, useLocation, useHistory } from 'react-router-dom';

import { getAlertDetailsById, getAlertList } from "../../services/index";
import { conversationtemplatecrud } from "../../services/chatFlowService";
import { LogoutDotNet } from '../../services/userAuthServices';

import ReactDOM from 'react-dom'
import Swal from 'sweetalert2'

import {
    CONFIGURATION,
    WORKFLOW, ROOT,
    PLAYER, CAMERA_SINGLE_PLAYBACK,
} from '../../navigation/CONSTANTS';
import Topbar from "../../components//Topbar/Topbar";
import PrivateRoute from '../../navigation/Auth/PrivateRoute';
import ConfigurationContainer from '../Configuration/ConfigurationContainer'
// import WorkflowContainer from '../Workflow/WorkflowContainer';
import ChatbotContainer from '../ChatbotWidget/ChatbotContainer';
import { useAuth } from '../../navigation/Auth/ProvideAuth';
import { NoAccessPage } from '../../navigation/NoAccess';
import {
    AddAlertRecord, DeleteAlertRecord, GetAllAlertRecord, GetAlertNotAckRecord,
    DeleteChatWindowOpenedTime, AddChatWindowOpenedTime
} from '../../utils/IndexedDBStorageUtil'
import Player from '../Player/Player';
// import SinglePlayback from '../Cameras/SinglePlayback';
import DrawerProvider from '../../Context/DrawerContext';
// import ChatbotAssociateCamera from '../ChatbotWidget/ChatbotAssociateCamera';
import { useProfile } from '../../CustomHooks/useProfile';
import { WarningToast } from '../../CustomHooks/WarningToast';
import { ALERT_INTERVAL_TIMER, ASSOC_DIRECT_OPEN, CHAT_CAM_CHANGES, MULTI_TIME_ZONE } from "../../config"
import { ConvertDate, getAlertDataUtils, logOutMain, multiTimeZoneHelper } from '../../utils/utils'
import MainContent from './MainContent';
import sound from './Alertbeep.wav'
import { GetSeverity } from '../../services/configurationServices';
import { GetTodaysAlertListUAPI } from '../../services/dashboardService';
import { checkAutoLogout } from '../../services/alertAuthService';
import { ConfigurationProvider } from '../../Context/ConfigurationContext';
import { ThemeContext } from '../../Context/ThemeContext';
import withLazyLoad from '../../HOC/withLazyLoad';
import withAccessAllowed from '../../HOC/withAccessAllowed';
import { AlertsModule } from '../../utils/ModuleConstants';

const LazyWorkflowContainer = withLazyLoad(() => import(/* webpackChunkName: "LazyWorkflowComponent" */'../Workflow/WorkflowContainer'))

const LazySinglePlayback = withLazyLoad(() => import(/* webpackChunkName: "LazySinglePlaybackComponent" */'../Cameras/SinglePlayback'))

// const LazyConfigurationComponent = withLazyLoad(() => import(/* webpackChunkName: "LazyConfigurationComponent" */'../Configuration/ConfigurationContainer'))

const LazyChatbotAssociateCamera = withLazyLoad(() => import(/* webpackChunkName: "LazyChatbotAssociateCamera"  */ '../ChatbotWidget/ChatbotAssociateCamera'))

const LazyNotFound = withLazyLoad(() => import(/* webpackChunkName: "LazyNotFound" */'./../../navigation/NotFound'))

let getMenusAccess = JSON.parse(localStorage.getItem('user'));
let menusAccess = getMenusAccess?.MenuList;

const checkViewOperation = (menuName) => {
    const menu = menusAccess?.find((item) => item.Menuname === menuName);
    return menu ? menu.ViewOperation : false;
};

const ProtectedConfigurataionTool = withAccessAllowed(ConfigurationContainer, checkViewOperation("Configuration Tool"))


export default function RootContainer() {
    let currentUser = useAuth()
    let location = useLocation()
    let history = useHistory()
    let LoggedInUser = JSON.parse(localStorage.getItem('user'))
    let hootRef = useRef(true);
    const { isDarkTheme, setIsDarkTheme } = useContext(ThemeContext)

    //#region useState start
    const [alertList, setAlertList] = useState(null)
    const [todaysAlertList, setTodaysAlertList] = useState(null)
    const [rootLoading, setRootLoading] = useState(false);
    const [alertcounts, setalertcounts] = useState({
        "TotalOpen": 0,
        "Extreme": 0,
        "High": 0,
        "Moderate": 0,
        "Low": 0,
        "TotalClosed": 0,
        "ExtremeClosed": 0,
        "HighClosed": 0,
        "ModerateClosed": 0,
        "LowClosed": 0,
        "TodaysAlerts": 0
    })
    const [selectedTab, setSelectedTab] = useState('dashboard')
    const [selectedSubMenu, setSelectedSubMenu] = useState(null)
    const [isSuperUser, setIsSuperUser] = useState(false);
    const { profile, getprofiledata } = useProfile();
    const [uniqueId, setUniqueId] = useState('');
    // const [isDarkTheme, setIsDarkTheme] = useState(true);
    const [cctvTypeName, setCctvTypeName] = useState('');
    const [camUserName, setCamUserName] = useState('');
    const [camPassword, setCamPassword] = useState('');
    const [brandName, setBrandName] = useState('');
    const [hootWay, setHootWay] = useState([]);
    const [openButton1, setOpenButton1] = useState(false);
    const [activeCam, setActiveCam] = useState(null);
    const [alertDetail, setAlertDetail] = useState([]);
    const [associateCam, setAssociateCam] = useState([]);
    const [alertSearch, setAlertSearch] = useState(false);
    const [activeSeverity, setActiveSeverity] = useState("all");
    const [childWindow, setChildWindow] = useState(null);
    const memoizedSetChildWindow = useCallback(
        (newState) => {
          setChildWindow(newState);
        },
        [] // Empty dependency array means this function is memoized forever (unless the component is unmounted)
      );
    const [alertChildWindow, setAlertChildWindow] = useState(null);
    const [chatHeads, setChatHeads] = useState([])
    const alertSoundRef = useRef(0);
    const lastAlertNoRef = useRef(0);
    const enableLowSeverityRef = useRef(false);
    const enableModerateSeverityRef = useRef(false);
    const enableHighSeverityRef = useRef(false);
    const enableExtremeSeverityRef = useRef(false);
    const enableSoundRef = useRef(false);
    const firstLoginRef = useRef(false);
    const [isplaySound, setIsPlaySound] = useState(true);
    const [toggleHide, setToggleHide] = useState(false);
    //#endregion useState end

    //#region useEffect start
    useEffect(() => {
        let timer;
        timer = setTimeout(()=>{
            GetTodaysAlertListNew()
        },1000)
        //getAll()
        return () => clearTimeout(timer);
    }, [])

    useEffect(() => {
        let arr = JSON.parse(localStorage.getItem('hootWayData'));
        if (arr == null) {
            setHootWay([]);
        } else {
            setHootWay(arr);
        }
    }, []);

    useEffect(() => {
        if (!hootRef.current) {
            let arr = hootWay;
            localStorage.setItem('hootWayData', JSON.stringify(arr));
        }
        return () => {
            hootRef.current = false;
        }
    }, [hootWay]);

    useEffect(() => {
        setUniqueId(LoggedInUser?.Id);
        let menuList = LoggedInUser?.MenuList;
        let configMenu = menuList?.find((item) => item?.Menuname == "Configuration Tool")
        setIsSuperUser(configMenu?.ViewOperation)
    }, [LoggedInUser]);

    useEffect(() => {
        (async () => {
            await getprofiledata()
            // if (location.pathname === "/allalerts") {
            await Getopenedchats()
            // }
            if (LoggedInUser && LoggedInUser.RoleId == 3) {
                await Getnotackalertslst()
            }
        })();

    }, [])
    //For dashboard alert docker and todays alert count

    useEffect(() => {
        const interval = setInterval(async () => {
            if (isSuperUser && uniqueId) { //tej 17022022 alert docker get refreshed after every 1 min if the current logged in user is root or admin
                // if (location.pathname === "/dashboard" || location.pathname === '/') {
                if (LoggedInUser && localStorage.getItem('authCode')) {
                    // await GetAlertCount()
                   // await GetTodaysAlertList()
                   await GetTodaysAlertListNew()
                   await checkAutoLogoutStatus()
                }
                // }  
            }
            else {
                // await 
                if (LoggedInUser && localStorage.getItem('authCode')) {
                    // await GetAlertCount()
                    //await GetTodaysAlertList()
                    await GetTodaysAlertListNew()
                    await checkAutoLogoutStatus()
                }
            }
        }, ALERT_INTERVAL_TIMER);
        return () => {
            clearInterval(interval);
        }
    }, [uniqueId]);

    //For All alert docker 
    
    // useEffect(() => {
    //     const interval = setInterval(async () => {
    //         if (location && location.pathname && (location.pathname === ALLALERTS) && !alertSearch) {
    //             await GetAlertList()
    //         }
    //     }, ALERT_INTERVAL_TIMER);
    //     return () => {
    //         clearInterval(interval);
    //     }
    // }, [uniqueId, location, alertSearch, activeSeverity]);

    useEffect(() => {
        if (LoggedInUser && localStorage.getItem('authCode')) {
            //GetTodaysAlertList();
                GetTodaysAlertListNew()
                checkAutoLogoutStatus()
            // GetAlertCount();
        }
    }, [])

    useEffect(() => {
        if (sessionStorage.getItem('mosaicWindowKey') == "mosaicWindow") {
            let interval = setInterval(() => {
                if (childWindow?.closed) {
                    sessionStorage.removeItem('mosaicWindowKey');
                }
            }, 2000);

            return () => {
                clearInterval(interval);
            }

        }
    }, [childWindow, sessionStorage.getItem('mosaicWindowKey')]);

    useEffect(() => {
        // Listen for the beforeunload event in the parent window
        const beforeUnloadListener = () => {
            if (childWindow) {
                //sessionStorage.removeItem("mosaicWindowKey")
               // childWindow.close();
            }
        };

        window.addEventListener('beforeunload', beforeUnloadListener);
        return () => {
            // Cleanup: Remove the event listener when the parent component unmounts
            window.removeEventListener('beforeunload', beforeUnloadListener);
        };

    }, [childWindow]);

    useEffect(() => {
        let intervalId
        if (childWindow) {
            intervalId = setInterval(() => {
                if (sessionStorage.getItem('mosaicWindowKey') == null || sessionStorage.getItem('mosaicWindowKey') === undefined || sessionStorage.getItem('mosaicWindowKey') === '') {
                    childWindow.close();
                }
            }, 100); // 100 milliseconds (0.1 seconds)
        }
        return () => {
            clearInterval(intervalId); // Clean up the interval on unmount
        }
    }, [childWindow]);


    //#region alertGridView Window
    useEffect(() => {
        if (sessionStorage.getItem('alertWindowKey') == "alertWindow") {
            let interval = setInterval(() => {
                if (alertChildWindow?.closed) {
                    sessionStorage.removeItem('alertWindowKey');
                }
            }, 2000);

            return () => {
                clearInterval(interval);
            }

        }
    }, [alertChildWindow, sessionStorage.getItem('alertWindowKey')]);

    useEffect(() => {
        // Listen for the beforeunload event in the parent window
        const beforeUnloadListener = () => {
            if (alertChildWindow) {
                // sessionStorage.removeItem("alertWindowKey")
                // alertChildWindow.close();
            }
        };

        window.addEventListener('beforeunload', beforeUnloadListener);
        return () => {
            // Cleanup: Remove the event listener when the parent component unmounts
            window.removeEventListener('beforeunload', beforeUnloadListener);
        };

    }, [alertChildWindow]);

    useEffect(() => {
        let intervalIdTwo
        if (alertChildWindow) {
            intervalIdTwo = setInterval(() => {
                if (sessionStorage.getItem('alertWindowKey') == null || sessionStorage.getItem('alertWindowKey') === undefined || sessionStorage.getItem('alertWindowKey') === '') {
                    alertChildWindow.close();
                }
            }, 100); // 100 milliseconds (0.1 seconds)
        }
        return () => {
            clearInterval(intervalIdTwo); // Clean up the interval on unmount
        }
    }, [alertChildWindow]);

    //#endregion

    //#region functions start
    const GetAlertCount = async () => {
        try {
            let dt;
        if(MULTI_TIME_ZONE){
            let loggedInUser = JSON.parse(localStorage.getItem('user'))
            let offSetMinutes = loggedInUser?.OffsetMinutes;
            dt = multiTimeZoneHelper(offSetMinutes)
          }else{
            dt = new Date();
          }
            var obj = {
                "action": "alertCount",
                "userUniqueId": LoggedInUser?.UserUniqueID,
                "authCode": localStorage.getItem('authCode'),
                "currentDate": dt.toJSON().slice(0, 10)
            }
            await getAlertList(obj).then((resp) => {
                if (resp && resp.status == "Ok") {
                    if (resp.message) {
                        setalertcounts(resp.message[0])
                        // setRootLoading(false);
                    }
                } else {
                    // alert(resp.message)
                    if (resp.message == "Unauthorized") {
                        if (localStorage.getItem('sessionExpired') == "true") {
                            localStorage.removeItem('sessionExpired');
                            sessionStorage.removeItem('mosaicWindowKey')
                            sessionStorage.removeItem('alertWindowKey')
                            return;
                        } else {
                            localStorage.setItem('sessionExpired', true)
                            sessionStorage.removeItem('mosaicWindowKey')
                            sessionStorage.removeItem('alertWindowKey')
                            Swal.fire({
                                text: 'Logged in from another machine, this session is expired you will be logged out from here.',
                                confirmButtonText: 'Ok',
                                allowOutsideClick: false,
                                timer: 5100,
                                timerProgressBar: true
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    LogoutDotNet().then((res) => {
                                        history.push('/login');
                                        logOutMain()
                                        let tempWindow = window.open('','mosaicWindow');
                                        let tempAlertWindow = window.open('','alertwindow');                
                                        if(childWindow != null){
                                            childWindow.close();
                                        }
                                        if(alertChildWindow != null){
                                            alertChildWindow.close();
                                        }
                                        if(tempWindow != null){
                                            tempWindow.close();
                                        }
                                        if(tempAlertWindow != null){
                                            tempAlertWindow.close();
                                        }
                                    })
                                }
                            }).catch(err => console.log("catcherr", err))
                            setTimeout(() => {
                                Swal.clickConfirm();
                            }, 5000);
                        }
                    }
                }
            })
        } catch (error) {
            console.error(error)
            // setRootLoading(false);
        }
    }

    const checkAutoLogoutStatus = async () => {
        try {
            await checkAutoLogout().then((resp) => {
                if (resp && resp.Status == "failed") {
                    if (resp.Message == "Unauthorized") {
                        if (localStorage.getItem('sessionExpired') == "true") {
                            localStorage.removeItem('sessionExpired');
                            sessionStorage.removeItem('mosaicWindowKey')
                            sessionStorage.removeItem('alertWindowKey')
                            return;
                        } else {
                            localStorage.setItem('sessionExpired', true)
                            sessionStorage.removeItem('mosaicWindowKey')
                            sessionStorage.removeItem('alertWindowKey')
                            Swal.fire({
                                text: 'Logged in from another machine, this session is expired you will be logged out from here.',
                                confirmButtonText: 'Ok',
                                allowOutsideClick: false,
                                timer: 5100,
                                timerProgressBar: true
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    history.push('/login');
                                        logOutMain()
                                        let tempWindow = window.open('','mosaicWindow');
                                        let tempAlertWindow = window.open('','alertwindow');                
                                        if(childWindow != null){
                                            childWindow.close();
                                        }
                                        if(alertChildWindow != null){
                                            alertChildWindow.close();
                                        }
                                        if(tempWindow != null){
                                            tempWindow.close();
                                        }
                                        if(tempAlertWindow != null){
                                            tempAlertWindow.close();
                                        }
                                }
                            }).catch(err => console.log("catcherr", err))
                            setTimeout(() => {
                                Swal.clickConfirm();
                            }, 5000);
                        }
                    }
                }
            })
        } catch (error) {
            console.error(error)
            // setRootLoading(false);
        }
    }

    const GetAlertList = async () => {
        try {
            var obj = {
                "action": "getAlertList",
                "severity": activeSeverity,
                "userUniqueId": LoggedInUser?.UserUniqueID,
                "startIndex": 0,
                "numberOfElements": 50,
                "authCode": localStorage.getItem('authCode')
            }
            await getAlertList(obj).then((resp) => {
                if (resp.status == "Ok") {
                    if (resp.message) {
                        setAlertList(resp.message)
                    }
                }
            })
        } catch (error) {
            console.error(error)
        }
    }

    const getAll = () => {
        let UserId = localStorage.getItem('UserID');
        
        try {
            GetSeverity(UserId).then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        let extreme = resp.Data.find((item) => item.SeverityId === 1);

                        enableExtremeSeverityRef.current = (extreme.PlaySound)
                        let high = resp.Data.find((item) => item.SeverityId === 2);

                        enableHighSeverityRef.current = (high.PlaySound)
                        let moderate = resp.Data.find((item) => item.SeverityId === 3);

                        enableModerateSeverityRef.current = (moderate.PlaySound)
                        let low = resp.Data.find((item) => item.SeverityId === 4);

                        enableLowSeverityRef.current = (low.PlaySound)

                        if (!enableExtremeSeverityRef.current && !enableHighSeverityRef.current && !enableModerateSeverityRef.current && !enableLowSeverityRef.current) {
                            setToggleHide(false)
                        } else {
                            setToggleHide(true)
                        }
                    }
                }
            })
        } catch (error) {
            console.error(error)
        }
    }

    const checkEnableSound = () => {
        let user = JSON.parse(localStorage.getItem('user'))
        if (user != null || user != undefined) {
            let temp = user.PlaySoundFlag == "1" ? true : false
            enableSoundRef.current = temp;
        }
    }
    const getFirstDate = () => {
        let d;
        let loggedInUser = JSON.parse(localStorage.getItem('user'))
        if (MULTI_TIME_ZONE) {
          d = multiTimeZoneHelper(loggedInUser?.OffsetMinutes)
        } else {
          d = new Date();
        }
        return d;
      }
    
      const getSecondDate = () => {
        let e;
        let loggedInUser = JSON.parse(localStorage.getItem('user'))
        if (MULTI_TIME_ZONE) {
          e = multiTimeZoneHelper(loggedInUser?.OffsetMinutes)
        } else {
          e = new Date();
        }
        return e;
      }

    const GetTodaysAlertListNew = async () =>{
        if(!checkViewOperation(AlertsModule)){
            return
        }
        let user = JSON.parse(localStorage.getItem('user'))
        checkEnableSound();
        getAll();
        setRootLoading(true);
        let dt;
        if(MULTI_TIME_ZONE){
            let loggedInUser = JSON.parse(localStorage.getItem('user'))
            let offSetMinutes = loggedInUser?.OffsetMinutes;
            dt = multiTimeZoneHelper(offSetMinutes)
          }else{
            dt = new Date();
          }
          
          try{
            let start = getFirstDate();
        let end = getSecondDate();
        let startDate = ConvertDate(new Date(start.setHours(0, 0, 0, 0)));
        let endCurrDate = ConvertDate(end);
            let obj ={
                
                    "UserId": user?.Id,
                    "FromDateTime": startDate,
                    "ToDateTime": endCurrDate,
                    "AlertId": null,
                    "ClientId": "",
                    "ClientName": "",
                    "SiteId": "",
                    "SiteName": "",
                    "BranchId": "",
                    "DeviceId": "",
                    "DeviceName": "",
                    "AckBy": "",
                    "AlertDateTime": "",
                    "AlertStatusId": "",
                    "AlertStatus": "",
                    "SeverityId": "",
                    "Severity": "",
                    "AlertCodeId": "",
                    "AlertType": ""
                  
            }
            await GetTodaysAlertListUAPI(obj).then((resp) => {
                if (resp.Status == "success") {
                    if(resp.Data == null){
                        setRootLoading(false);
                        return
                    }
                    if (resp.Data) {
                        setTodaysAlertList(resp.Data)
                        setRootLoading(false);
                        //to get data from localstorage (PlaySoundFlag)
                        const soundPlay = localStorage.getItem('PlaySound');
                        let temp = soundPlay == "true" ? true : false
                        let recentAlertId = resp.Data.length > 0 ? resp.Data[0].AlertId : 0
                        // First Check, to check if the enable sound is true or false on the topbar.
                        if (temp) {
                            // if (alertSoundRef.current < resp.message.length && firstLoginRef.current) {
                            // Second Check, to check if the recent alert id is not equal to last saved recent alert
                            if (lastAlertNoRef.current != recentAlertId && firstLoginRef.current) {
                                // let difference = resp.message.length - alertSoundRef.current
                                let difference;
                                // Below Logic is to check the difference to get the count of the newly raised alerts.
                                if (lastAlertNoRef.current == 0) {
                                    difference = resp.Data.length;
                                } else {
                                    difference = resp.Data[0].AlertId - lastAlertNoRef.current;
                                }
                                //Below logic is to get the list of the newly raised alerts
                                let newAlert = resp.Data.slice(0, difference).map(item => item.Severity)
                                let playsound = false;
                                //Below logic is to iterate through the newly raised alerts and check their severity and raised the alert sound if the severity is enabled.
                                for (let i = 0; i < difference; i++) {
                                    if (newAlert[i] == "Extreme" && enableExtremeSeverityRef.current) {
                                        playsound = true;
                                        break;
                                    } else if (newAlert[i] == "Moderate" && enableModerateSeverityRef.current) {
                                        playsound = true;
                                        break;
                                    } else if (newAlert[i] == "High" && enableHighSeverityRef.current) {
                                        playsound = true;
                                        break;
                                    } else if (newAlert[i] == "Low" && enableLowSeverityRef.current) {
                                        playsound = true;
                                        break;
                                    } else {
                                        continue;
                                    }

                                }
                                //If playsound flag is true then play the sound otherwise it will go to the else block.
                                if (playsound) {
                                    alertSoundRef.current = resp.Data.length
                                    lastAlertNoRef.current = recentAlertId
                                    // let audio = new Audio('./Alertbeep.wav');
                                    let audio = document.getElementById("myAudio")
                                    audio.play()
                                }
                                else {
                                    alertSoundRef.current = resp.Data.length
                                    lastAlertNoRef.current = recentAlertId
                                }
                            } else {
                                alertSoundRef.current = resp.Data.length
                                lastAlertNoRef.current = recentAlertId
                            }
                        } else {
                            alertSoundRef.current = resp.Data.length
                            lastAlertNoRef.current = recentAlertId
                        }
                        firstLoginRef.current = true
                    }
                }
            })
          }catch (error) {
            setRootLoading(false);
        }
    }

    const GetTodaysAlertList = async () => {
        checkEnableSound();
        getAll();
        setRootLoading(true);
        let dt;
        if(MULTI_TIME_ZONE){
            let loggedInUser = JSON.parse(localStorage.getItem('user'))
            let offSetMinutes = loggedInUser?.OffsetMinutes;
            dt = multiTimeZoneHelper(offSetMinutes)
          }else{
            dt = new Date();
          }
        try {
            var obj = {
                "action": "getTodaysAlertsList",
                "userUniqueId": LoggedInUser?.UserUniqueID,
                "startIndex": 0,
                "numberOfElements": 50,
                "authCode": localStorage.getItem('authCode'),
                "currentDate": dt.toJSON().slice(0, 10),
                "loadBalance": LoggedInUser?.ApplicationFlag || "0"
            }
            await getAlertList(obj).then((resp) => {
                if (resp.status == "Ok") {
                    if (resp.message) {
                        setTodaysAlertList(resp.message)
                        setRootLoading(false);
                        //to get data from localstorage (PlaySoundFlag)
                        const soundPlay = localStorage.getItem('PlaySound');
                        let temp = soundPlay == "true" ? true : false
                        let recentAlertId = resp.message.length > 0 ? resp.message[0].alertId : 0
                        // First Check, to check if the enable sound is true or false on the topbar.
                        if (temp) {
                            // if (alertSoundRef.current < resp.message.length && firstLoginRef.current) {
                            // Second Check, to check if the recent alert id is not equal to last saved recent alert
                            if (lastAlertNoRef.current != recentAlertId && firstLoginRef.current) {
                                // let difference = resp.message.length - alertSoundRef.current
                                let difference;
                                // Below Logic is to check the difference to get the count of the newly raised alerts.
                                if (lastAlertNoRef.current == 0) {
                                    difference = resp.message.length;
                                } else {
                                    difference = resp.message[0].alertId - lastAlertNoRef.current;
                                }
                                //Below logic is to get the list of the newly raised alerts
                                let newAlert = resp.message.slice(0, difference).map(item => item.severity)
                                let playsound = false;
                                //Below logic is to iterate through the newly raised alerts and check their severity and raised the alert sound if the severity is enabled.
                                for (let i = 0; i < difference; i++) {
                                    if (newAlert[i] == "Extreme" && enableExtremeSeverityRef.current) {
                                        playsound = true;
                                        break;
                                    } else if (newAlert[i] == "Moderate" && enableModerateSeverityRef.current) {
                                        playsound = true;
                                        break;
                                    } else if (newAlert[i] == "High" && enableHighSeverityRef.current) {
                                        playsound = true;
                                        break;
                                    } else if (newAlert[i] == "Low" && enableLowSeverityRef.current) {
                                        playsound = true;
                                        break;
                                    } else {
                                        continue;
                                    }

                                }
                                //If playsound flag is true then play the sound otherwise it will go to the else block.
                                if (playsound) {
                                    alertSoundRef.current = resp.message.length
                                    lastAlertNoRef.current = recentAlertId
                                    // let audio = new Audio('./Alertbeep.wav');
                                    let audio = document.getElementById("myAudio")
                                    audio.play()
                                }
                                else {
                                    alertSoundRef.current = resp.message.length
                                    lastAlertNoRef.current = recentAlertId
                                }
                            } else {
                                alertSoundRef.current = resp.message.length
                                lastAlertNoRef.current = recentAlertId
                            }
                        } else {
                            alertSoundRef.current = resp.message.length
                            lastAlertNoRef.current = recentAlertId
                        }
                        firstLoginRef.current = true
                    }
                }
            })
        } catch (error) {
            setRootLoading(false);
        }
    }
    // const playSound = () => {
    //     let audio=document.getElementById("myAudio")
    //     audio.play()
    // }

    let alertnotacktime = 2
    const EscallateAlert = async (id) => {
        try {
            var obj = {
                "action": "escalateAlert",
                "alertId": id,
                "userId": LoggedInUser.UserID,
                "datetime": ConvertDate(new Date())
            }
            return;
            /* ------- Added Return Statement to stop the reassigning alert issue ------- */
            await conversationtemplatecrud(obj).then((resp) => {
                if (resp.status == "Ok") {
                    onCloseAlertChat(id)
                    DeleteChatWindowOpenedTime(id)
                    GetAlertList()
                } else {
                    alert(resp.message)
                }
            })
        } catch (error) {
            console.error(error)
        }
    }
    const Getopenedchats = async () => {
        try {
            var res = await GetAllAlertRecord()
            res.onsuccess = function (event) {
                if (event.target.result.length > 0) {
                    let arr = event.target.result.map((item) => {
                        let obj = {
                            ...item,
                            isOpen: false
                        }
                        return obj;
                    })
                    setChatHeads(arr)
                    // setChatHeads(event.target.result)
                }
            };
        } catch (error) {
            console.error(error)
        }
    }
    const Getnotackalertslst = async () => {
        try {
            var res = await GetAlertNotAckRecord()
            res.onsuccess = function (event) {
                if (event.target.result != []) {
                    event.target.result.map((item) => {
                        var sec = parseInt((new Date() - new Date(item.alertWindowOpenTime)) / 1000)
                        var min = parseInt(sec / 60)
                        if (min > alertnotacktime) {
                            var fulltime = alertnotacktime + alertnotacktime
                            if (min > fulltime) {
                                //alert("AlertId_"+item.alertId+" - Escallate api calling!")
                                EscallateAlert(item.alertId)
                            } else {
                                var lefttime = fulltime - min
                                var escallateimer = setTimeout(() => {
                                    //alert("AlertId_"+item.alertId+" - Escallate api calling!")
                                    clearTimeout(escallateimer)
                                    //DeleteChatWindowOpenedTime(item.alertId)
                                    EscallateAlert(item.alertId)
                                }, lefttime * 60 * 1000)
                                //AddEscallationTimerList(item.alertId,null,escallateimer)
                                AddChatWindowOpenedTime(item.alertId, null, escallateimer)
                            }
                        } else {
                            var lefttime = alertnotacktime - min
                            var notifytimer = setTimeout(() => {
                                var escallateimer = setTimeout(() => {
                                    //alert("AlertId_"+item.alertId+" - Escallate api calling!")

                                    clearTimeout(escallateimer)
                                    EscallateAlert(item.alertId)
                                    //DeleteChatWindowOpenedTime(item.alertId)
                                }, alertnotacktime * 60 * 1000)
                                //AddEscallationTimerList(item.alertId,null,escallateimer)
                                AddChatWindowOpenedTime(item.alertId, null, escallateimer)
                                // alert("AlertId_" + item.alertId + " - Please acknowledge your alert, if you don't this alert will get reassigned.")
                                clearTimeout(notifytimer)
                            }, lefttime * 60 * 1000)
                            //AddEscallationTimerList(item.alertId,notifytimer,null)
                            AddChatWindowOpenedTime(item.alertId, notifytimer, null)
                        }
                    })
                }
            };
        } catch (error) {
            console.error(error)
        }
    }

    const Setalertnotacktimeout = (id) => {
        try {
            var notifytimer = setTimeout(() => {
                var escallateimer = setTimeout(() => {
                    //alert("AlertId_"+id+" - Escallate api calling!")

                    clearTimeout(escallateimer)
                    EscallateAlert(id)
                    //DeleteChatWindowOpenedTime(id)
                }, alertnotacktime * 60 * 1000)
                AddChatWindowOpenedTime(id, null, escallateimer)
                // alert("AlertId_" + id + " - Please acknowledge your alert, if you don't this alert will get reassigned.")
                clearTimeout(notifytimer)
            }, alertnotacktime * 60 * 1000)
            //AddEscallationTimerList(id,notifytimer,null)
            AddChatWindowOpenedTime(id, notifytimer, null)

        } catch (error) {
            console.error(error)
        }
    }

    async function onAddAlertChat(id) {
        try {
            let res = chatHeads.find(chat => chat.alertId == id)
            if (!res) {
                if (chatHeads.length > 3) {
                    WarningToast("Max 4 chat widgets allowed")
                    return false
                }
                return await getAlertDetailsById(id).then((resp) => {
                    if (resp.Status == "success") {
                        if(resp.Data){
                        let alertData = resp.Data.data
                        let tempArrObj = getAlertDataUtils(alertData,id)
                        if (ASSOC_DIRECT_OPEN) {
                            setAlertDetail(tempArrObj);
                        }
                        setCctvTypeName(tempArrObj.cctvtype)
                        setCamUserName(tempArrObj.camUserName)
                        setCamPassword(tempArrObj.camPassword)
                        setBrandName(tempArrObj.brandName)
                        if (tempArrObj.workflowId != null) {
                            setChatHeads(prev => [...prev, tempArrObj])
                            AddAlertRecord(tempArrObj)
                            let isItDisabled = true;
                            let user_id = localStorage.getItem('UserID');
                            if (tempArrObj.assignedTo != null && tempArrObj.assignedTo == user_id) {
                                isItDisabled = false
                            }

                            let tempObj = {
                                alertId: id,
                                twoWayStatus: true,
                                hooterStatus: true,
                                btnDisabled: isItDisabled,
                                deviceId: tempArrObj.deviceId,
                                hideReassign: tempArrObj?.AlertStatusId === 3 ? true : false
                            }
                            setHootWay([...hootWay, tempObj]);
                            if (CHAT_CAM_CHANGES) {
                                let secondObj = {
                                    alertId: id,
                                    alertDetail: tempArrObj,
                                    display: false,
                                    logText: "",
                                    shouldRefresh: false
                                }
                                setAssociateCam([...associateCam, secondObj]);
                            }
                            return true
                        } else {
                            Swal.fire({ text: "Workflow not configured for " + tempArrObj.alertTemplate })
                            return false
                        }
                    }
                    }
                })
            } else {
                return false
            }
        } catch (error) {
            return false
        }
    }

    const getUpdatedAlertDetails = (id) => {
         getAlertDetailsById(id).then((resp) => {
            if (resp.Status == "success") {
              if (resp.Data) {
                let alertData = resp.Data.data
                let tempArrObj = getAlertDataUtils(alertData, id)
                setCctvTypeName(tempArrObj.cctvtype)
                setCamUserName(tempArrObj.camUserName)
                setCamPassword(tempArrObj.camPassword)
                setBrandName(tempArrObj.brandName)
                if (CHAT_CAM_CHANGES) {
                  let secondObj = {
                    alertId: id,
                    alertDetail: tempArrObj,
                    display: false,
                    logText: "",
                    shouldRefresh: false
                  }
                  setAssociateCam([...associateCam, secondObj]);
                }
                let tempArr = chatHeads.map(x => x);
                let newArr = tempArr.map((item) => {
                    if(item.AlertId == id){
                        return tempArrObj;
                    }
                    return item;
                })
                setChatHeads(newArr);
                try {

                } catch (error) {
                  console.error(error)
                }
              }
            }
          })
    }

    const onCloseAlertChat = (id) => {
        try {
            let arr = hootWay;
            let tempArr = arr.filter((item) => item.alertId != id.alertId);
            setHootWay(tempArr);
            ReactDOM.unmountComponentAtNode(document.getElementById("Chatbotcomponentdiv:AlertID-" + id.alertId))
        } catch (error) {
            console.error(error)
        }
        let data = chatHeads.filter((value) => {
            return value.alertId !== id.alertId
        })
        setChatHeads(data)
        DeleteAlertRecord(id.alertId)
    }

    const onCloseAlertOnDeviceId = (id) => {
        try {
            let tempArr = hootWay.filter((item) => item.deviceId != id);
            setHootWay(tempArr);
            let alertIds = chatHeads.filter((item) => item.DeviceId == id); 
            let data = chatHeads.filter((value) => {
                return value.DeviceId !== id
            })
            setChatHeads(data)
            for(let i=0; i<alertIds.length; i++){
                DeleteAlertRecord(alertIds[i].alertId)
            }
            for(let i=0; i<alertIds.length; i++){
                ReactDOM.unmountComponentAtNode(document.getElementById("Chatbotcomponentdiv:AlertID-" + alertIds[i].alertId))
                // DeleteAlertRecord(alertIds[i].alertId)
            }
        } catch (error) {
            console.log(error);
        }
    }

    const onMaximizeAlertChat = (id) => {
        let data = chatHeads.filter((value) => {
            return value.alertId !== id
        })
        setChatHeads(data)
        DeleteAlertRecord(id)
        history.push(`/chatflow/${id}`)
    }

    const onChatOpen = (alertId) => {
        let arr = chatHeads.map((item) => {
            let obj;
            if (alertId == item.alertId) {
                obj = {
                    ...item,
                    isOpen: !item.isOpen
                }
            } else {
                obj = {
                    ...item
                }
            }
            return obj;
        })
        setChatHeads(arr);
    }

    //#endregion functions end

    function renderSwitch(param, onAddAlert, onCloseAlertChat) {
        return <Switch>
            <PrivateRoute path={PLAYER}>
                <Player />
            </PrivateRoute>
            <PrivateRoute path={CONFIGURATION}>
                {/* {isSuperUser ? <ConfigurationContainer getAllfromParent={getAll} isDarkTheme={isDarkTheme} /> : <NoAccessPage />} */}
                <ConfigurationProvider>
                    <ProtectedConfigurataionTool getAllfromParent={getAll} isDarkTheme={isDarkTheme} onCloseAlertOnDeviceId={onCloseAlertOnDeviceId} />
                </ConfigurationProvider>
            </PrivateRoute>
            <PrivateRoute path={WORKFLOW}>
                { isSuperUser ? <LazyWorkflowContainer /> : <NoAccessPage /> }
            </PrivateRoute>
            {/*  <PrivateRoute path={ABOUTMH}>
                <AboutContainer/>
            </PrivateRoute> */}
            <PrivateRoute path={ROOT}>
                <MainContent
                    isSuperUser={isSuperUser}
                    alerts={alertList}
                    onAddAlertChat={onAddAlert}
                    ResetAlertList={GetAlertList}
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                    selectedSubMenu={selectedSubMenu}
                    setSelectedSubMenu={setSelectedSubMenu}
                    alertcounts={alertcounts}
                    rootLoading={rootLoading}
                    ResetAlertCounts={GetAlertCount}
                    todaysAlertList={todaysAlertList}
                    uniqueId={uniqueId}
                    cctvTypeName={cctvTypeName}
                    camUserName={camUserName}
                    camPassword={camPassword}
                    brandName={brandName}
                    hootWay={hootWay}
                    setHootWay={setHootWay}
                    alertSearch={alertSearch}
                    setAlertSearch={setAlertSearch}
                    activeSeverity={activeSeverity}
                    setActiveSeverity={setActiveSeverity}
                    childWindow={childWindow}
                    setChildWindow={memoizedSetChildWindow}
                    alertChildWindow={alertChildWindow}
                    setAlertChildWindow={setAlertChildWindow}
                    isDarkTheme={isDarkTheme}
                    setIsDarkTheme={setIsDarkTheme}
                    setAlertDetail={setAlertDetail}
                    setOpenButton1={setOpenButton1}
                    openButton1={openButton1}
                    activeCam={activeCam}
                    setActiveCam={setActiveCam}
                    setCctvTypeName={setCctvTypeName}
                    setCamUserName={setCamUserName}
                    setCamPassword={setCamPassword}
                    setBrandName={setBrandName}
                    associateCam={associateCam}
                    setAssociateCam={setAssociateCam}
                    checkEnableSound={checkEnableSound}
                    setIsPlaySound={setIsPlaySound}
                    isplaySound={isplaySound}
                    onCloseAlertOnDeviceId={onCloseAlertOnDeviceId}
                />
            </PrivateRoute>
            <PrivateRoute path={CAMERA_SINGLE_PLAYBACK}>
                <LazySinglePlayback />
            </PrivateRoute>
            <Route path="*">
                <LazyNotFound />
            </Route>
        </Switch>
    }

    return (
        <>
            <DrawerProvider>
                <div className="container-fluid p-0">
                    <Topbar profile={profile} childWindow={childWindow} alertChildWindow={alertChildWindow} setIsPlaySound={setIsPlaySound} isplaySound={isplaySound} toggleHide={toggleHide} />
                    <audio id="myAudio">
                        <source src={sound} type="audio/wav" />
                    </audio>

                    {/* All Config Routes here */}
                    <main className="mainDiv">
                        {
                            renderSwitch(
                                location.pathname,
                                onAddAlertChat)
                        }
                    </main>
                </div>
                {
                    currentUser &&
                    <ChatbotContainer
                        chatHeads={chatHeads}
                        onCloseAlertChat={onCloseAlertChat}
                        onMaximizeAlertChat={onMaximizeAlertChat}
                        ResetAlertList={GetAlertList}
                        onChatOpen={onChatOpen}
                        cctvTypeName={cctvTypeName}
                        camUserName={camUserName}
                        camPassword={camPassword}
                        brandName={brandName}
                        hootWay={hootWay}
                        setHootWay={setHootWay}
                        openButton1={openButton1}
                        setOpenButton1={setOpenButton1}
                        setAlertDetail={setAlertDetail}
                        activeCam={activeCam}
                        setActiveCam={setActiveCam}
                        associateCam={associateCam}
                        setAssociateCam={setAssociateCam}
                        getUpdatedAlertDetails={getUpdatedAlertDetails}
                    />
                }

                {
                    CHAT_CAM_CHANGES
                        ?
                        associateCam.map((item) => (
                            <>
                                {
                                    item.display
                                        ?
                                        <LazyChatbotAssociateCamera key={item.alertId} id={item.alertId} openButton1={item.display} setOpenButton1={setOpenButton1} alertDetail={item.alertDetail} associateCam={associateCam} setAssociateCam={setAssociateCam} />
                                        : null
                                }
                            </>
                        ))
                        :
                        openButton1 && <LazyChatbotAssociateCamera openButton1={openButton1} setOpenButton1={setOpenButton1} activeCam={activeCam} setActiveCam={setActiveCam} alertDetail={alertDetail} />
                }
            </DrawerProvider>
        </>
    )
}